import { GlobalLoaderProvider } from "@/components/GlobalLoader";
import { ImpressaoConfigProvider } from "./ImpressaoConfigContext";
import { MobileProvider } from "./MobileContext";
import { UsuarioProvider } from "./UsuarioContext";
import { LocalizacoesProvider } from "./LocalizacoesContext";
import { CategoriasProvider } from "./CategoriasContext";
import { SeriaisProvider } from "./SeriaisContext";
import { EpcProvider } from "./EpcContext";
import { ImpressaoProvider } from "@/components/ImpressaoComponent";
import { LeitoresProvider } from "./LeitoresContext";
import { SocketProvider } from "./SocketContext";
import { FirmwareProvider } from "./FirmwareContext";
import { ItemProvider } from "./ItemContext";
import { OrdensDeImpressaoProvider } from "./OrdensDeImpressaoContext";
import { HistoricoProvider } from "./HistoricoContext";
import { ContaConfigProvider } from "./ContaConfigContext";
import { ImpressaoPanvelProvider } from "@/components/Personalizados/ImpressaoPanvelComponent";
import { AdminProvider } from "./AdminContext";
import { VerificarImpressaoProvider } from "./VerificarImpressaoContext";
import { FilaImpressaoSocketProvider } from "./FilaImpressaoSocketContext";
import { SincronizacaoProvider } from "./SincronizacaoContext";
import { AlertModalProvider } from "./AlertModalContext";
import { AlertBridge } from "@/components/AlertBridge";

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MobileProvider>
      <AlertModalProvider>
        <AlertBridge />
        <GlobalLoaderProvider>
          <AdminProvider>
            <UsuarioProvider>
              <ContaConfigProvider>
                <SeriaisProvider>
                  <CategoriasProvider>
                    <ImpressaoConfigProvider>
                      <SocketProvider>
                        <FirmwareProvider>
                          <FilaImpressaoSocketProvider>
                            <OrdensDeImpressaoProvider>
                              <HistoricoProvider>
                                <LocalizacoesProvider>
                                  <ItemProvider>
                                    <VerificarImpressaoProvider>
                                      <EpcProvider>
                                        <ImpressaoProvider>
                                          <ImpressaoPanvelProvider>
                                            <LeitoresProvider>
                                              <SincronizacaoProvider>
                                                {children}
                                              </SincronizacaoProvider>
                                            </LeitoresProvider>
                                          </ImpressaoPanvelProvider>
                                        </ImpressaoProvider>
                                      </EpcProvider>
                                    </VerificarImpressaoProvider>
                                  </ItemProvider>
                                </LocalizacoesProvider>
                              </HistoricoProvider>
                            </OrdensDeImpressaoProvider>
                          </FilaImpressaoSocketProvider>
                        </FirmwareProvider>
                      </SocketProvider>
                    </ImpressaoConfigProvider>
                  </CategoriasProvider>
                </SeriaisProvider>
              </ContaConfigProvider>
            </UsuarioProvider>
          </AdminProvider>
        </GlobalLoaderProvider>
      </AlertModalProvider>
    </MobileProvider>
  );
};
